import { render, staticRenderFns } from "./EventsActionNeededPage.vue?vue&type=template&id=3bbbecb0&"
import script from "./EventsActionNeededPage.vue?vue&type=script&lang=js&"
export * from "./EventsActionNeededPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports